import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Router, UrlTree } from "@angular/router";
import { Observable, of } from "rxjs";
import { catchError, map, take } from "rxjs/operators";
import { FeaturesService } from "../services/features.service";
import { Features } from "../enums/Features";

@Injectable({
  providedIn: "root"
})
export class FeatureFlagGuard {
  constructor(
    private readonly featuresService: FeaturesService,
    private readonly router: Router
  ) { }

  canActivate = (route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> => {
    const flag = route.data["featureFlag"] as Features;
    return this.featuresService.getFeatures().pipe(
      take(1),
      map((features) =>
        features?.find((f) => f.name === flag)?.enabled === true
          ? true
          : this.router.parseUrl("/not-found")
      ),
      catchError(() => of(this.router.parseUrl("/not-found")))
    );
  }
}
